import React, { Component } from "react";
import { connect } from "react-redux";
import CaseForm from "../NewCase";
import PostApi from "../../api/PostApi";
import api from "../../api/api";
import * as newCaseActions from "../NewCase/actions";
import { bindActionCreators } from "redux";
import { arrayMove } from "react-sortable-hoc";
import { push, goBack } from "redux-little-router";
import { showAlert } from "../../actions";
import { selectUserToken, selectUser } from "../../util/selectors";
import { constructPostSlugPath } from "../../util/index";
import { loadMorePosts } from "../../actions";
import { watchNewCaseRequests } from "./sagas";
import { connectSaga } from "../../util/hoc/connectSaga";
import mixpanel from "../../services/mixpanel";
import { showConfirmDialog, hideConfirmDialog } from "../../actions";
import NotFoundPage from "../../scenes/App404";

class CaseFormContainer extends Component {
  constructor(props) {
    super(props);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.handleChoosingImages = this.handleChoosingImages.bind(this);
    this.handleUploadedImage = this.handleUploadedImage.bind(this);
    this.toggleCoverImage = this.toggleCoverImage.bind(this);
    this.updateCaption = this.updateCaption.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.handleInfoChange = this.handleInfoChange.bind(this);
    this.edit = this.edit.bind(this);

    this.state = {
      currentStep: 0,
      orderingMode: false,
      images: [],
      info: {
        title: "",
        description: "",
        caseType: "",
      },
      publishing: false,
      loading: false,
      owner: {
        id: null,
        name: "",
        picture: "",
      },
      slug: "",
    };

    this.actions = {
      ...this.props.actions,
      onSortEnd: this.onSortEnd,
      handleChoosingImages: this.handleChoosingImages,
      handleUploadedImage: this.handleUploadedImage,
      toggleCoverImage: this.toggleCoverImage,
      updateCaption: this.updateCaption,
      deleteImage: this.deleteImage,
      handleInfoChange: this.handleInfoChange,
      publish: this.edit,
    };
  }

  componentWillMount() {
    if (!this.props.data.guid && !this.props.isEdit) {
      this.props.actions.getGUID();
    }
  }

  componentDidMount() {
    if (this.props.isEdit) {
      this.setState({
        ...this.state,
        loading: true,
      });
      const { url } = this.getLoadPostUrl(this.props.currentRouteParams);
      api.get(url).then(({ data }) => {
        if (this.props.isEdit && !this.isAdminEdit()) {
          if (data.owner.id !== this.props.user.uid) {
            return this.setState({
              ...this.state,
              unauthorized: true,
            });
          }
        }
        this.setState({
          ...this.state,
          info: {
            title: data.title,
            description: data.description,
            caseType: data.caseType,
          },
          guid: data.albumGuid,
          images: data.images.map(img => ({
            ...img,
            id: img.uuid,
            name: img.caption,
            src: img.url,
            uploaded: true,
          })),
          loading: false,
          _id: data._id,
          slug: data.slug,
          owner: data.owner,
        });
      });
    }
  }

  getLoadPostUrl(routeParams) {
    const { caseid, slug } = routeParams;
    if (slug) {
      return PostApi.getLoadPostBySlugUrl(slug);
    } else if (caseid) {
      return PostApi.getLoadPostByIdUrl(caseid);
    } else {
      console.error("error ", routeParams);
    }
  }

  onSortEnd({ oldIndex, newIndex }) {
    this.setState({
      ...this.state,
      images: arrayMove(this.state.images, oldIndex, newIndex),
    });
  }

  handleChoosingImages(images) {
    this.setState({
      ...this.state,
      images: [...this.state.images, ...images],
    });
  }

  handleUploadedImage({ name, uuid, id }) {
    this.setState({
      ...this.state,
      images: this.state.images.map(
        img =>
          img.id === name
            ? {
                ...img,
                fileId: id,
                uploaded: true,
                uuid: uuid,
              }
            : img
      ),
    });
  }

  toggleCoverImage(coverImageId) {
    this.setState({
      ...this.state,
      images: this.state.images.map(
        ({ isCover, ...image }) => (image.id === coverImageId ? { ...image, isCover: !isCover } : { ...image })
      ),
    });
  }

  updateCaption(imageId, caption) {
    this.setState({
      ...this.state,
      images: this.state.images.map(
        image =>
          image.id === imageId
            ? {
                ...image,
                caption: caption,
              }
            : image
      ),
    });
  }

  deleteImage(imageId) {
    this.setState({
      ...this.state,
      images: this.state.images.filter(image => image.id !== imageId),
    });
  }

  handleInfoChange(changesObj) {
    this.setState({
      ...this.state,
      info: {
        ...this.state.info,
        ...changesObj,
      },
    });
  }

  edit(post) {
    if (this.isAdminEdit()) {
      return this.editAsAdmin(post);
    }
    return this.editAsUser(post);
  }

  editAsAdmin(post) {
    PostApi.editPostAsAdmin(post._id, post)
      .then(() => this.handlePostUpdate(post))
      .catch(err => console.log(err));
  }

  editAsUser(post) {
    PostApi.editPost(post._id, post)
      .then(() => {
        //TEMP untill edit is moved to redux
        mixpanel.track("post.edit", { id: post._id });
        this.handlePostUpdate(post);
      })
      .catch(err => console.log(err));
  }

  handlePostUpdate(post) {
    const postRoute = constructPostSlugPath(post);
    this.props.actions.push(postRoute);
    this.props.actions.showAlert("Edited successfully");
    this.props.actions.loadMorePosts({ override: true });
  }

  isAdminEdit() {
    const isAdminEditRoute =
      this.props.currentRoute === "/admin/posts/:caseid/edit" || this.props.currentRoute === "/admin/case/:slug/edit";
    return this.props.user.isAdmin && isAdminEditRoute;
  }

  render() {
    if (this.state.unauthorized) {
      return <NotFoundPage />;
    }
    return (
      <CaseForm
        accessToken={this.props.accessToken}
        user={this.props.user}
        data={this.props.isEdit ? this.state : this.props.data}
        actions={this.props.isEdit ? this.actions : this.props.actions}
        loading={this.state.loading}
        isEditForm={this.props.isEdit}
        isAdminEdit={this.isAdminEdit()}
        prevRoute={this.props.prevRoute}
      />
    );
  }
}

function isEdit(state) {
  return !!(state.router.params.caseid || state.router.params.slug);
}

const mapStateToProps = state => {
  return {
    user: selectUser(state),
    accessToken: selectUserToken(state),
    data: state.newCase,
    caseid: state.router.params.caseid,
    isEdit: isEdit(state),
    currentRoute: state.router.route,
    currentRouteParams: state.router.params,
    prevRoute: state.router.previous,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(
        {
          ...newCaseActions,
          push,
          goBack,
          showAlert,
          loadMorePosts,
          showConfirmDialog,
          hideConfirmDialog,
        },
        dispatch
      ),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(connectSaga(CaseFormContainer, watchNewCaseRequests));



// WEBPACK FOOTER //
// ./src/scenes/CaseFormContainer/index.js